class EmployeeSearchTagsController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  removeEmployeeFilter(employee) {
    this.onRemoveEmployeeFilter(this.EventEmitter(employee));
  }

  cleanEmployeeFilters() {
    this.onCleanEmployeeFilters();
  }

}

export default EmployeeSearchTagsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeSearchTags/employeeSearchTags.controller.js